import { createSlice } from "@reduxjs/toolkit";
import { downloadAiCampaignSampleCsvAPI } from "../../services/downloadAiCampaignSampleCsv";

const data = {
  isLoading: false,
  error: "",
  message: "",
  data: null,
};

const downloadAiCampaignSampleCsvSlice = createSlice({
  name: "downloadAiCampaignSampleCsv",
  initialState: data,
  reducers: {
    downloadAiCampaignSampleCsvInfo(state) {
      state.isLoading = true;
      state.error = "";
      state.message = "";
    },
    downloadAiCampaignSampleCsvInfoSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.message = action.payload?.message || "Sample CSV downloaded successfully";
      state.error = "";
    },
    downloadAiCampaignSampleCsvInfoFailure(state, action) {
      state.isLoading = false;
      state.message = "";
      state.error = action.payload;
      state.data = null;
    },
    downloadAiCampaignSampleCsvInfoReset(state) {
      state.isLoading = false;
      state.message = "";
      state.data = null;
      state.error = "";
    },
  },
});

export const downloadAiCampaignSampleCsvHandler = () => async (dispatch) => {
  try {
    dispatch(downloadAiCampaignSampleCsvAction.downloadAiCampaignSampleCsvInfo());
    const response = await downloadAiCampaignSampleCsvAPI();
    dispatch(
      downloadAiCampaignSampleCsvAction.downloadAiCampaignSampleCsvInfoSuccess(response)
    );
  } catch (e) {
    dispatch(
      downloadAiCampaignSampleCsvAction.downloadAiCampaignSampleCsvInfoFailure(
        e?.response?.data?.message || e?.message || e
      )
    );
  }
};

export default downloadAiCampaignSampleCsvSlice.reducer;
export const downloadAiCampaignSampleCsvAction =
  downloadAiCampaignSampleCsvSlice.actions;
